"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("@emotion/react/jsx-runtime");
const react_redux_1 = require("react-redux");
const roomCreateStore_1 = require("@/room/room_create/roomCreateStore");
const react_i18next_1 = require("react-i18next");
const svgs_1 = require("@@/assets/svgs");
const Button_1 = __importDefault(require("@mui/material/Button"));
function default_1() {
    const dispatch = (0, react_redux_1.useDispatch)();
    const goBackToFirstStep = () => dispatch((0, roomCreateStore_1.setRoomCreateStep)('1'));
    const { t } = (0, react_i18next_1.useTranslation)();
    return ((0, jsx_runtime_1.jsxs)(Button_1.default, Object.assign({ onClick: goBackToFirstStep, sx: {
            height: '32px',
            columnGap: '8px',
            p: '0 12px 0 8px',
            borderRadius: '8px',
            border: '1px solid var(--gray-80)',
            lineHeight: '22px',
            fontSize: '15px',
            color: 'var(--gray-80)',
            bgcolor: 'var(--white) !important',
        } }, { children: [(0, jsx_runtime_1.jsx)(svgs_1.ChevronLeftSvg, {}), t('배송국가 변경')] })));
}
exports.default = default_1;
